webpackJsonp([51],{

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var lib = {
	isEmpty: function isEmpty(arg) {
		if (Array.isArray(arg)) {
			return arg.length === 0;
		}
		if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(arg)) === 'object' && arg !== null) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(arg).length === 0;
		}
		if (typeof arg === 'string' || typeof arg === 'number') {
			return !arg;
		}
		return !arg;
	}
};
/* harmony default export */ __webpack_exports__["a"] = (lib);

/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-page',{attrs:{"name":"roles-global","title":_vm.$route.meta.title}}),_vm._v(" "),_c('RolesGlobalList',{on:{"edit-role":_vm.editingRole}}),_vm._v(" "),_c('ActionSidebar',{attrs:{"title":_vm.titleComputed},model:{value:(_vm.slide),callback:function ($$v) {_vm.slide=$$v},expression:"slide"}},[_c('NewRoleForm',{on:{"close-modal":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_global_roles_vue__ = __webpack_require__(850);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4c2713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_global_roles_vue__ = __webpack_require__(1089);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_global_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4c2713_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_global_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_lib__ = __webpack_require__(1080);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function closeModal() {
	this.slide = false;
	this.currentRole = {};
}

function titleComputed() {
	return __WEBPACK_IMPORTED_MODULE_1__shared_lib__["a" /* default */].isEmpty(this.currentRole) ? 'Nuevo Rol' : 'Editar Rol';
}

function editingRole(rol) {
	this.currentRole = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rol);
	this.openModal();
}

function openModal() {
	this.slide = true;
}

function data() {
	return {
		currentRole: {},
		slide: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-global-roles',
	components: {
		ActionSidebar: function ActionSidebar() {
			return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 164));
		},
		NewRoleForm: function NewRoleForm() {
			return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1081));
		},
		RolesGlobalList: function RolesGlobalList() {
			return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1085));
		}
	},
	computed: {
		titleComputed: titleComputed
	},
	data: data,
	methods: {
		closeModal: closeModal,
		editingRole: editingRole,
		openModal: openModal
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.f506c9f411763b57c795.js